import { render, staticRenderFns } from "./AddCooperate.vue?vue&type=template&id=06924519&scoped=true&"
import script from "./AddCooperate.vue?vue&type=script&lang=js&"
export * from "./AddCooperate.vue?vue&type=script&lang=js&"
import style0 from "./AddCooperate.vue?vue&type=style&index=0&id=06924519&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06924519",
  null
  
)

export default component.exports